const POLYDATA_FIELDS = ['verts', 'lines', 'polys', 'strips'];
var Constants = {
  POLYDATA_FIELDS
};

export { POLYDATA_FIELDS, Constants as default };
